<div *ngIf="office && office.advertiser">
  <div class="flex align-items-start justify-content-between">
    <h3>InfoAdex</h3>
    <button
      *ngIf="hasRole('db-edit-offices')"
      pButton
      label="Add InfoAdex"
      type="button"
      (click)="createClicked()"
      class="p-button-raised p-button-warning"
      icon="pi pi-plus-circle"
      style="margin-bottom: 10px"
    ></button>
  </div>
  <p-table
    class="infoadex-table"
    #dt
    styleClass="p-datatable-sm"
    [value]="office.advertiser.infoAdexRecords"
    [loading]="isLoading"
    [scrollable]="true"
    selectionMode="single"
  >
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between"></div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Year</th>
        <th>Ranking</th>
        <th>Investment</th>
        <th class="actions" *ngIf="hasRole('db-edit-offices')">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-infoAdex>
      <tr>
        <td>{{ infoAdex.year }}</td>
        <td>{{ infoAdex.ranking }}</td>
        <td>{{ infoAdex.investment }}</td>
        <td class="actions" *ngIf="hasRole('db-edit-offices')">
          <button
            pButton
            type="button"
            icon="pi pi-file-edit"
            class="p-button-outlined p-button-warning"
            (click)="editClicked($event, infoAdex)"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-warning"
            (click)="confirmDelete($event, infoAdex)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">
        In total there are
        {{ office.advertiser.infoAdexRecords ? office.advertiser.infoAdexRecords.length : 0 }} InfoAdex records.
      </div>
    </ng-template>
  </p-table>

  <p-toast></p-toast>
  <p-confirmPopup></p-confirmPopup>
</div>
